import clsx from 'clsx'
import { C1Icon } from 'components/core/icons/C1Icon'
import { useStyles } from 'components/core/task/outcome/styles'
import { Ban, CircleAlert, CircleCheck, Hourglass, XCircle } from 'lucide-react'
import { CertifyOutcome, GrantOutcome, RevokeOutcome } from 'pbts/c1/api/task/v1/task'
import React from 'react'

export const OutcomeIcon = ({
    outcome,
    applyStyles = false,
}: {
    outcome: CertifyOutcome | GrantOutcome | RevokeOutcome
    applyStyles?: boolean
}): React.ReactElement => {
    const classes = useStyles()
    switch (outcome) {
        case CertifyOutcome.CERTIFIED:
        case GrantOutcome.GRANTED:
        case RevokeOutcome.REVOKED:
            return (
                <C1Icon
                    icon={CircleCheck}
                    className={clsx({ [classes.outcomeIcon]: applyStyles, [classes.approved]: true })}
                    sx={{
                        display: 'block',
                    }}
                />
            )
        case CertifyOutcome.DECERTIFIED:
        case GrantOutcome.DENIED:
        case RevokeOutcome.DENIED:
            return (
                <C1Icon
                    icon={Ban}
                    className={clsx({ [classes.outcomeIcon]: applyStyles, [classes.denied]: true })}
                    sx={{
                        display: 'block',
                    }}
                />
            )
        case CertifyOutcome.ERROR:
        case GrantOutcome.ERROR:
        case RevokeOutcome.ERROR:
            return (
                <C1Icon
                    icon={CircleAlert}
                    aria-label="error"
                    className={clsx({ [classes.outcomeIcon]: applyStyles, [classes.error]: true })}
                />
            )
        case CertifyOutcome.CANCELLED:
        case GrantOutcome.CANCELLED:
        case RevokeOutcome.CANCELLED:
            return (
                <C1Icon
                    icon={XCircle}
                    aria-label="error"
                    className={clsx({ [classes.outcomeIcon]: applyStyles, [classes.cancelled]: true })}
                />
            )
        case CertifyOutcome.UNSPECIFIED:
        case GrantOutcome.UNSPECIFIED:
        case RevokeOutcome.UNSPECIFIED:
        default:
            return (
                <C1Icon
                    icon={Hourglass}
                    aria-label="pending"
                    className={clsx({ [classes.outcomeIcon]: applyStyles, [classes.pending]: applyStyles })}
                />
            )
    }
}
